import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Section from './Section';
import Point from './Point';
import OKNOKDropField from './OKNOKDropField/OKNOKDropField';
import TextField from './TextField';
import GeneralPhoto from './GeneralPhoto';

function SectionManagement({ versions, dataIndex, disable }) {

  const renderSwitch = (element, versionIndex, dataIndex) => {

    switch(element.type) {
      case 'generalPhoto':
        return (<GeneralPhoto
          generalPhoto={element}
          dataIndex={dataIndex}
          versionIndex={versionIndex}
          disable={disable}
        />);
      case 'textField':
        return (<TextField
          textfield={element}
          dataIndex={dataIndex}
          versionIndex={versionIndex}
          disable={disable}
        />);
      case 'section':
        return <Section
          section={element}
          dataIndex={dataIndex}
          versionIndex={versionIndex}
          disable={disable}
        />
      case 'point':
        return <Point
          point={element}
          dataIndex={dataIndex}
          versionIndex={versionIndex}
          disable={disable}
        />
      case 'okNok':
        return <OKNOKDropField
          oknok={element}
          dataIndex={dataIndex}
          versionIndex={versionIndex}
          disable={disable}
        />
      default:
        return '';
    }
  }
  return (<div>
    {versions[dataIndex] && versions[dataIndex].data && versions[dataIndex].data.map((element, index) => (
      <div>
        <p>
          {element.number}
        </p>
        {renderSwitch(element, dataIndex, index)}
      </div>
      )
    )}
  </div>);
}

function mapStateToProps ({ instructionsReducer }) {
  return {
    ...instructionsReducer
  };
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionManagement);
